<h1 mat-dialog-title>اطلاعات زیر را با دقت تکمیل نمایید</h1>
<div mat-dialog-content>
  <app-select-field
    [Group]="formGroup"
    [fieldName]="'visitType'"
    [fieldLabel]="'نوع ویزیت'"
    [options]="typesList"
  ></app-select-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">بازگشت</button>
  <button mat-button [disabled]="!formGroup.valid" (click)="submit()" cdkFocusInitial>تایید
  </button>
</div>
